import React from 'react'
import { ReactComponent as FamilyIcon } from 'assets/icons/family_restroom.svg'
import { ReactComponent as ForumIcon } from 'assets/icons/forum.svg'
import { ReactComponent as MailIcon } from 'assets/icons/mail.svg'
import { ReactComponent as ArrowLongIcon } from 'assets/icons/arrow_back.svg'
import { ReactComponent as AnalyticsIcon } from 'assets/icons/analitic.svg'
import { ReactComponent as LightbulbIcon } from 'assets/icons/lightbulb.svg'
import { ReactComponent as BugIcon } from 'assets/icons/bug_report.svg'
import { ReactComponent as PhoneIcon } from 'assets/icons/phone.svg'
import { ReactComponent as TurnedInIcon } from 'assets/icons/assignment_turned_in.svg'
import { ReactComponent as EventBusyIcon } from 'assets/icons/calendar_cross.svg'
import { ReactComponent as PersonAddIcon } from 'assets/icons/person_add.svg'
import { ReactComponent as MarkChatIcon } from 'assets/icons/message_dot.svg'
import { ReactComponent as LanguageIcon } from 'assets/icons/language.svg'
import { ReactComponent as PenIcon } from 'assets/icons/pen.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'
import { ReactComponent as UniversityIcon } from 'assets/icons/university.svg'
import { ReactComponent as HierarchyIcon } from 'assets/icons/arrow-diagram.svg'
import { ReactComponent as ChevronDownIcon } from 'assets/icons/cheveron-down.svg'

const filledMaterialIcon = iconName => function FilledMaterialIcon({ className = '', ...props }) {
	return <span {...props} className={`material-icons ${className}`.trim()}>{iconName}</span>
}

const BellIcon = filledMaterialIcon('notifications')
const QuestionIcon = filledMaterialIcon('help')
const CalendarIcon = filledMaterialIcon('event')

export const SETTINGS_ICONS = {
	family: FamilyIcon,
	bell: BellIcon,
	help: QuestionIcon,
	forum: ForumIcon,
	mail: MailIcon,
	arrowForward: ArrowLongIcon,
	analytics: AnalyticsIcon,
	lightbulb: LightbulbIcon,
	bug: BugIcon,
	phone: PhoneIcon,
	turnedIn: TurnedInIcon,
	eventBusy: EventBusyIcon,
	personAdd: PersonAddIcon,
	markChat: MarkChatIcon,
	language: LanguageIcon,
	pen: PenIcon,
	check: CheckIcon,
	university: UniversityIcon,
	hierarchy: HierarchyIcon,
	chevronDown: ChevronDownIcon,
	calendar: CalendarIcon,
}

export const getSettingsIcon = iconKey => SETTINGS_ICONS[iconKey] || QuestionIcon
